import React, { PureComponent } from 'react';
import { faPaperclip } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import CountOfTotalButton from 'features/messengerv2/TeamEmailsView/CountOfTotalButton';

import Box from 'components/Box';
import Icon from 'components/Icon';
import ListItem from 'components/ListItem';
import Text from 'components/Text';

import cxHelpers from 'util/className';
import { toI18n } from 'util/i18n';

@cxHelpers('MessageDrawerListItem')
export default class MessageDrawerListItem extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    footer: PropTypes.string,
    hasUnread: PropTypes.bool,
    handleClick: PropTypes.func.isRequired,
    shouldShowBullet: PropTypes.bool,
    showPinnedPill: PropTypes.bool,
    attachmentsCount: PropTypes.number,
    pinned: PropTypes.bool,
    canManage: PropTypes.bool,
    teamAnnouncement: PropTypes.object,
    acknowledgedCount: PropTypes.number,
    recipientsCount: PropTypes.number,
    needsAcknowledgment: PropTypes.bool,
    requiresAcknowledgment: PropTypes.bool,
    showAnnouncementSummary: PropTypes.func,
    isManagerial: PropTypes.bool,
  };

  render() {
    const {
      title,
      subTitle,
      time,
      footer,
      hasUnread,
      handleClick,
      shouldShowBullet,
      showPinnedPill,
      attachmentsCount,
      pinned,
      needsAcknowledgment,
      requiresAcknowledgment,
      acknowledgedCount,
      recipientsCount,
      isManagerial,
    } = this.props;

    return (
      <Box bb className={this.cx()}>
        <ListItem theme="blue-hover" button onClick={handleClick}>
          <Box pvxxs phxs row>
            {shouldShowBullet && (
              <Box w={24}>
                {hasUnread && <Icon type="circle" size="xs" color="blue" />}
              </Box>
            )}
            <Box plxs w="100%">
              <Box spacebetween baseline>
                <Box w={210} ellipsis>
                  <Text fs14 grayXdark={!hasUnread} fw600 navy={hasUnread}>
                    {title}
                  </Text>
                </Box>

                <Text
                  uppercase
                  fs12
                  grayXdark={!hasUnread}
                  navy={hasUnread}
                  fw600={hasUnread}
                >
                  {time}
                </Text>
              </Box>

              <Box w={250} maxh={30} ellipsis>
                <Text
                  grayXdark={!hasUnread}
                  navy={hasUnread}
                  fs14
                  fw600={hasUnread}
                  asHTML
                >
                  {subTitle}
                </Text>
              </Box>

              <Box w={250} ellipsis>
                <Text grayXdark fs12 fw400>
                  {footer}
                </Text>
              </Box>

              {(attachmentsCount ||
                (requiresAcknowledgment && isManagerial) ||
                (needsAcknowledgment && !isManagerial) ||
                pinned) && (
                <Box mt={9} row spacebetween>
                  {isManagerial && requiresAcknowledgment && (
                    <CountOfTotalButton
                      total={recipientsCount}
                      count={acknowledgedCount}
                      onClick={this.props.showAnnouncementSummary}
                    />
                  )}

                  <Box row vcenter>
                    {attachmentsCount !== undefined && attachmentsCount > 0 && (
                      <div className={this.cxEl('attachments', {}, 'mr24')}>
                        <Text fs12 purple>
                          <FontAwesomeIcon icon={faPaperclip} />
                          {` ${attachmentsCount}`}
                        </Text>
                      </div>
                    )}

                    {pinned && !showPinnedPill && (
                      <div>
                        <Text purple fs12>
                          <i className="fas fa-thumbtack mr4" />

                          {toI18n('message_drawer.team_announcements.pinned')}
                        </Text>
                      </div>
                    )}
                  </Box>
                  {/* NOTE: only display needs acknowledgment button when it is needed and
                  the user is an employee. */}
                  {!isManagerial && needsAcknowledgment && (
                    <Box>
                      <Text
                        i18n="message_drawer.team_announcements.acknowledgment"
                        fs12
                        purple
                      />
                    </Box>
                  )}
                </Box>
              )}

              {pinned && showPinnedPill && (
                <Box mt={9} w={130} bg="blue" ph4 pv={0} bradius={3} tcenter>
                  <Text
                    i18n="message_drawer.team_emails.pinned_announcement"
                    fs10
                    white
                    fw700
                    uppercase
                    bold
                    lspacing={0.3}
                    lh={1.8}
                  />
                </Box>
              )}
            </Box>
          </Box>
        </ListItem>
      </Box>
    );
  }
}
